// /admin/v1/users — read-only user directory.

import { get, list } from './client';
import type { ListResult } from './client';

export type Platform = 'wx_miniapp' | 'dy_miniapp' | 'h5' | 'ios' | string;

export interface AdminUser {
  id: string;
  nickname?: string | null;
  phone_masked?: string | null;
  platforms?: Platform[];
  lifetime_value_cents?: number;
  diamond_balance?: number;
  created_at?: string;
  last_active_at?: string | null;
}

export interface ListUsersQuery {
  q?: string;
  app_id?: number;
  min_ltv_cents?: number;
  page?: number;
  page_size?: number;
}

export function listUsers(q: ListUsersQuery = {}): Promise<ListResult<AdminUser>> {
  return list<AdminUser>('/admin/v1/users', q);
}

export interface AdminUserDetail extends AdminUser {
  app_relations?: Array<{
    app_id: number;
    app_slug: string;
    open_id?: string;
    union_id?: string;
    invited_by_user_id?: string | null;
    created_at?: string;
  }>;
  recent_orders?: Array<{
    id: string;
    amount_cents: number;
    status: string;
    created_at: string;
  }>;
}

export function getUser(id: string): Promise<AdminUserDetail> {
  return get<AdminUserDetail>(`/admin/v1/users/${id}`);
}
